export default function (props: any) {
    return (
        <svg width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="m.6 12.336 5.657-5.4L.6 1.536"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
